import * as $ from 'jquery';
import Typed from 'typed.js';
import '../__vendors/slick.min.js';

$(window).on('load', function() {
    $('.ai__hero-carousel').css('visibility', 'visible');
    $('.ai__sidekick-slider').css('visibility', 'visible');
    let typedInstances = {};

    function initializeTyped(target, strings, onCompleteCallback) {
        if (typedInstances[target]) {
            typedInstances[target].destroy();
            $(target).html('');
            $(target).removeClass('slide');
        }

        let typedInstance = new Typed(target, {
            strings: strings,
            typeSpeed: 10,
            backSpeed: 20,
            startDelay: 500,
            loop: false,
            showCursor: false,
            preStringTyped: function(arrayPos, self) {
                if (window.innerWidth <= 991) {
                    $(target).removeClass('slide');
                }

            },
            onComplete: function() {
                let typedText = document.querySelector(target);

                if (window.innerWidth <= 991) {
                    if (typedText.innerText.length > 60) {
                        $(target).addClass('slide');
                        checkOverflow(target);
                    }
                }
                if (window.innerWidth <= 440) {
                    if (typedText.innerText.length > 34) {
                        $(target).addClass('slide');
                        checkOverflow(target);
                    }
                }
                onCompleteCallback();
            }
        });

        typedInstances[target] = typedInstance;
    }

    function checkOverflow(target) {
        let typedText = document.querySelector(target);
        if (window.innerWidth <= 991) {
            if (typedText.innerText.length > 60) {
                void typedText.offsetWidth;
                $(typedText).addClass('slide');
            }
        }
        if (window.innerWidth <= 440) {
            if (typedText.innerText.length > 34) {
                void typedText.offsetWidth;
                $(typedText).addClass('slide');
            }
        }
    }

    function initializeProgressBar(progressBarContainer, presentationText) {
        $(progressBarContainer).show();
        $(progressBarContainer).find('.progress-bar-1').css('display', 'block').on('animationend', function() {
            $(presentationText).css('opacity', '1').show();
            $(progressBarContainer).hide();
        });
        $(progressBarContainer).find('.progress-bar-2').css('display', 'block');
    }

    function hideProgressBar(progressBarContainer) {
        $(progressBarContainer).find('.progress-bar-1').css('display', 'none');
        $(progressBarContainer).find('.progress-bar-2').css('display', 'none');
    }

    function hideAllProgressBars() {
        $('.progress-bar-container').each(function() {
            hideProgressBar(this);
            $(this).siblings('p').css('opacity', '0').hide();
        });
    }

    function initializeTileRecommendations() {
        $('#tile-container').css('opacity', '1');

        $('#tile-container .tile img').hide();

        $('#tile-container .tile').each(function() {
            let tile = $(this);
            tile.css({
                background: 'linear-gradient(45deg, rgba(128, 43, 212, 0.8), rgba(21, 36, 50, 0.8))',
                backgroundSize: '400% 400%',
                animation: 'none',
                transition: 'all 0.5s ease'
            });

            tile[0].offsetHeight;

            setTimeout(function() {
                tile.css('animation', 'gradient 2s ease infinite');

                setTimeout(function() {
                    tile.css('animation', 'none');
                    tile.find('img').fadeIn();
                }, 2000);
            }, 10);
        });
    }

    function initializeTileContainer() {
        $('.tile-container-2').css('opacity', '1');

        $('#tile-container-2 .tile').each(function() {
            let tile = $(this);
            tile.find('.tile-content').css({
                opacity: '0',
                transition: 'all 0.5s ease'
            });
            tile.find('.tile-content').hide();

            tile.css({
                background: 'linear-gradient(45deg, rgba(128, 43, 212, 0.8), rgba(21, 36, 50, 0.8))',
                backgroundSize: '400% 400%',
                animation: 'none',
                transition: 'all 0.5s ease'
            });

            tile[0].offsetHeight;

            setTimeout(function() {
                tile.css('animation', 'gradient 2s ease infinite');

                setTimeout(function() {
                    tile.css('animation', 'none');
                    tile.find('.tile-content').css({
                        opacity: '1',
                        display: 'flex'
                    }).fadeIn();
                }, 2000);
            }, 10);
        });
    }

    function initializeTileSecondContainer() {
        $('.tile-container-4').css('opacity', '1');

        $('#tile-container-4 .tile').each(function() {
            let tile = $(this);
            tile.find('.tile-content').css({
                opacity: '0',
                transition: 'all 0.5s ease'
            });
            tile.find('.tile-content').hide();

            tile.css({
                background: 'linear-gradient(45deg, rgba(128, 43, 212, 0.8), rgba(21, 36, 50, 0.8))',
                backgroundSize: '400% 400%',
                animation: 'none',
                transition: 'all 0.5s ease'
            });

            tile[0].offsetHeight;

            setTimeout(function() {
                tile.css('animation', 'gradient 2s ease infinite');

                setTimeout(function() {
                    tile.css('animation', 'none');
                    tile.find('.tile-content').css({
                        opacity: '1',
                        display: 'flex'
                    }).fadeIn();
                }, 2000);
            }, 10);
        });
    }

    function initializeStatisticsContainer() {
        $('.tile-container-3').css('opacity', '1');

        $('#tile-container-3 .tile').each(function() {
            let tile = $(this);
            tile.find('.tile-content').css({
                opacity: '0',
                transition: 'all 0.5s ease'
            });
            tile.find('.tile-content').hide();

            tile.css({
                background: 'linear-gradient(45deg, rgba(128, 43, 212, 0.8), rgba(21, 36, 50, 0.8))',
                backgroundSize: '400% 400%',
                animation: 'none',
                transition: 'all 0.5s ease'
            });

            tile[0].offsetHeight;

            setTimeout(function() {
                tile.css('animation', 'gradient 2s ease infinite');

                setTimeout(function() {
                    tile.css('animation', 'none');
                    tile.css('background', 'transparent');
                    tile.find('.tile-content').css({
                        opacity: '1',
                        display: 'block'
                    }).fadeIn();
                }, 2000);
            }, 10);
        });

        $('.tile-container-3').find('.speedbar-needle').css('animation', 'none');
        $('.tile-container-3 .speedbar-needle')[0].offsetHeight;

        setTimeout(function() {
            $('.tile-container-3').find('.speedbar-needle').css('animation', 'moveNeedle 2s ease-in-out forwards');
        }, 10);
    }

    // ai hero slick carousel
    $('.ai__hero-carousel').slick({
        dots: false,
        infinite: true,
        speed: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        centerMode: true,
        centerPadding: true,
        draggable: false,
        swipe: false,
        touchMove: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        cssEase: 'linear'
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        hideAllProgressBars();
        if (currentSlide === 2) {
            $('#tile-container').css('opacity', '0').find('.tile img').hide();
            $('#tile-container .tile').each(function() {
                $(this).css('background', 'none');
                $(this).find('img').fadeIn();
            });
        }
        if (currentSlide === 3) {
            $('#tile-container-2').css('opacity', '0');
        }
        if (currentSlide === 4) {
            $('#tile-container-3').css('opacity', '0');
        }
        if (currentSlide === 5) {
            $('#tile-container-4').css('opacity', '0');
        }
    }).on('afterChange', function(event, slick, currentSlide) {
        switch (currentSlide) {
            case 0:
                initializeTyped('#typed-text-1', ["Regular expression to find Contact’s visits like https://example.com/category/bikes"], function() {
                    initializeProgressBar('#progress-bar-container-1', '#presentation-text-1');
                });
                break;
            case 1:
                initializeTyped('#typed-text-2', ["Summer campaign ideas for sunscreen sale"], function() {
                    initializeProgressBar('#progress-bar-container-2', '#presentation-text-2');
                });
                break;
            case 2:
                initializeTyped('#typed-text-3', ["Best product recommendations for Jane Doe"], function() {
                    initializeTileRecommendations();
                });
                break;
            case 3:
                initializeTyped('#typed-text-4', ["Most effective channel to reach John Smith"], function() {
                    initializeTileContainer();
                });
                break;
            case 4:
                initializeTyped('#typed-text-5', ["Purchase probability within next 30 days for Joe Schmoe"], function() {
                    initializeStatisticsContainer();
                });
                break;
            case 5:
                initializeTyped('#typed-text-6', ["Contacts from Spain who opened an email within the past 30 days but not made a purchase"], function() {
                    initializeTileSecondContainer();
                });
                break;
        }
    });

    initializeTyped('#typed-text-1', ["Regular expression to find Contact’s visits like https://example.com/category/bikes"], function() {
        initializeProgressBar('#progress-bar-container-1', '#presentation-text-1');
    });

    // ai sidekick slick carousel
    $('.ai__sidekick-slider').slick({
        autoplay: true,
        autoplaySpeed: 3300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        arrows: false,
        dots: false,
        adaptiveWidth: true,
        draggable: false,
        swipe: false,
        touchMove: false,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

    function animateProgressBar(progressBar) {
        progressBar.css({
            'transition': 'width 1s linear',
            'width': '5%'
        });

        setTimeout(function() {
            progressBar.css({
                'transition': 'width 3s linear',
                'width': '100%'
            });
        }, 1000);
    }

    $('.ai__sidekick-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        let progressBar = $('.ai__sidekick-progress-bar-element');
        animateProgressBar(progressBar);
    });

    $('.ai__sidekick-slider').on('afterChange', function(event, slick, currentSlide) {
        let progressBar = $('.ai__sidekick-progress-bar-element');
        animateProgressBar(progressBar);
    });

    let progressBar = $('.ai__sidekick-progress-bar-element');
    progressBar.css({
        'transition': 'width 3s linear',
        'width': '100%'
    });
})

document.addEventListener('DOMContentLoaded', function() {
    const progressBarElements = document.querySelectorAll('.ai__recommendations-product-progress');
    const targetSection = document.querySelector('.ai__recommendations-product');
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    progressBarElements.forEach((progressBar, index) => {
                        const percent = progressBar.getAttribute('data-percent');
                        progressBar.style.width = `${percent}%`;
                        progressBar.classList.add('filled');

                        if (index === 0 || index === 3) {
                            const additionalElement = document.createElement('div');
                            additionalElement.classList.add('ai__recommendations-additional-element');
                            progressBar.parentElement.parentElement.appendChild(additionalElement);
                            setTimeout(() => {
                                additionalElement.classList.add('show');
                            }, 800);
                        }
                    });
                }, 1000);

                observer.unobserve(entry.target);
            }
        });
    }, options);

    observer.observe(targetSection);


    // labels change opacity
    const vertexLabels = document.querySelectorAll('.ai__predictions-star .label');
    const spiderImages = document.querySelectorAll('.ai__predictions-star .spider');
    const targetSectionStar = document.querySelector('.ai__predictions-star');
    const optionsStar = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const observerStar = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let delay = 0;
                const speed = 300;

                spiderImages.forEach((img, index) => {
                    setTimeout(() => {
                        img.style.transition = 'opacity 0.3s';
                        img.style.opacity = '1';

                        if (index > 0 && index < spiderImages.length - 1) {
                            spiderImages[index - 1].style.opacity = '0';
                        }

                        if (index === spiderImages.length - 1) {
                            setTimeout(() => {
                                spiderImages[index - 1].style.opacity = '0';
                            }, speed);
                        }
                    }, delay);
                    delay += speed;
                });

                setTimeout(() => {
                    vertexLabels.forEach(label => {
                        label.style.opacity = '1';
                    });
                }, delay + speed);

                observerStar.unobserve(entry.target);
            }
        });
    }, optionsStar);

    observerStar.observe(targetSectionStar);

});

// mobile sliders
const initTilesCarousel = () => {
    const tilesCarousels = $('[id*="aiSliderMobile"]');

    tilesCarousels.each(function() {
        const carousel = $(this);
        let sliderEnabled = false;

        const checkSliderEnabled = () => {
            const windowWidth = $(window).width();
            sliderEnabled = windowWidth !== undefined && windowWidth <= 991;

            if (sliderEnabled) {
                if (!carousel.hasClass('slick-initialized')) {
                    const options = {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        autoplay: true,
                        infinite: true,
                        draggable: false,
                        responsive: [{
                            breakpoint: 565,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: true,
                            }
                        }, ]
                    };
                    carousel.slick(options);
                }
            } else {
                if (carousel.hasClass('slick-initialized')) {
                    carousel.slick('unslick');
                }
            }
        };

        $(window).on('resize', checkSliderEnabled);

        checkSliderEnabled();
    });
};

$(document).ready(() => {
    initTilesCarousel();
});

// section animate
const animateTextOnScroll = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const section = entry.target;
            const textZone = section.querySelector(".ai__text-zone");

            if (textZone) {
                const headings = textZone.querySelectorAll("h2");
                const paragraphs = textZone.querySelectorAll("article p");
                const listItems = textZone.querySelectorAll(".ai__text-zone li");
                const buttons = textZone.querySelectorAll(".btn-ai");

                let delay = 0;

                headings.forEach((heading, index) => {
                    setTimeout(() => {
                        heading.classList.add("animate-text");
                    }, delay);
                    delay += 400;
                });

                paragraphs.forEach((paragraph, index) => {
                    setTimeout(() => {
                        paragraph.classList.add("animate-text");
                    }, delay);
                    delay += 150;
                });

                listItems.forEach((listItem, index) => {
                    setTimeout(() => {
                        listItem.classList.add("animate-text-horizontally");
                    }, delay);
                    delay += 400;
                });

                buttons.forEach((button, index) => {
                    setTimeout(() => {
                        button.classList.add("animate-text");
                    }, delay);
                    delay += 400;
                });
            }

            observer.unobserve(section);
        }
    });
};

const entrySection = () => {
    const fallingSections = document.querySelectorAll("[data-falling]");

    fallingSections.forEach(section => {
        const observerConfig = {
            rootMargin: "0px",
            threshold: 0.5
        };

        const observer = new IntersectionObserver(animateTextOnScroll, observerConfig);
        observer.observe(section);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth >= 992) {
        entrySection();
    }
});

window.addEventListener("resize", () => entrySection());
